import { useMemo } from "react";
import _ from "underscore";

const useReferencedAction = ({ action, actions }) => {
  const moduleAPIName = useMemo(() => {
    if (!action?.ReferencedAction) return undefined;

    const referencedAction = _.findWhere(actions, {
      id: action.ReferencedAction,
    });

    return referencedAction?.ModuleAPIName;
  }, [action?.ReferencedAction, actions]);

  return { moduleAPIName };
};

export default useReferencedAction;
